
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { ReelFrame } from "./ReelFrame";

export class ReelFrameComponent extends AbstractDisplayComponent {
    private container: ReelFrame;

    public setAnim(skel: string, atlas: string) {
        this.init();
        this.container = new ReelFrame(skel, atlas);
    }

    public getInstance(): Spine {
        return this.container.getAnim();
    }

    public override destroy(): void {
        this.container.destroy();
    }

    public upgrade(height: number, callback: () => void) {
        this.container.upgrade(height, callback);
    }
}

